import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);
const store = new Vuex.Store({
  // 设备ID
  state: {
    deviceID: localStorage.getItem("deviceID") || "",
    appData: null,
  },
  // 更新设备ID
  mutations: {
    setDeviceID(state, deviceID) {
      state.deviceID = deviceID;
      localStorage.setItem("deviceID", deviceID); // 持久化到 localStorage
    },
    // 更新主题
    setAppData(state, appData) {
      state.appData = appData;
      localStorage.setItem("themeConfig", JSON.stringify(appData)); // 持久化到 localStorage
    },
  },
  // 更新设备ID
  actions: {
    updateDeviceID({ commit }, deviceID) {
      commit("setDeviceID", deviceID);
    },
  },
  // 获取设备ID
  getters: {
    getDeviceID: (state) => state.deviceID,
  },
});
export default store;
